import { WithoutId } from "../models/WithoutId"

export function removeId<T extends { id: string }>(resource: T): WithoutId<T> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { id, ...rest } = resource
    return {
        ...rest,
    }
}
